

const variables = {
   'naira' : 570.1,
   'buynaira' : 530

};

export default variables;

